export default __webpack_public_path__ + "static/media/bggif.06b2cf73.gif";